// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"DatafaxForms__wrapper__3IlXU","submitResult":"DatafaxForms__submitResult__vAjuJ","actionWrapper":"DatafaxForms__actionWrapper__1m1ex","activateWrap":"DatafaxForms__activateWrap__3QARP","wrapper2faOptions":"DatafaxForms__wrapper2faOptions__3ieMt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DatafaxForms/DatafaxForms.css
// module id = 338
// module chunks = 0